// The Group page's member directory (no board draws it; Account.dc.html's switch, "Show me in the
// Property Accelerator's member directory", and Adam's 2 Oct answer bring it back): the members of
// the whole Accelerator, every group (Adam's answer 1 of 7 Oct), who've switched it on in Account, by
// name, each with their photo (or initials), their group, where they invest and a line about them,
// never an email or phone (hub.group_directory). Its lines name the product, not a group. Photos come
// through sign-file, signed for 2 minutes, 40 people a call; anyone it doesn't sign shows initials,
// and so does everyone while staff view as a member (sign-file opens nothing then).
import { useEffect, useState } from 'react'
import { Link } from '../../lib/router.jsx'
import { COPY } from './copy.js'
import { directoryView } from './model.js'
import { loadDirectory, signAvatars } from './data.js'

export function Directory({ productId, productName, viewingAs }) {
  const [state, setState] = useState({ status: 'loading', rows: [] })
  const [photos, setPhotos] = useState({})

  function load() {
    setState(s => ({ ...s, status: 'loading' }))
    loadDirectory(productId)
      .then(rows => setState({ status: 'ready', rows: directoryView(rows) }))
      .catch(() => setState({ status: 'error', rows: [] }))
  }
  useEffect(load, [productId])

  const withPhoto = state.rows.filter(r => r.hasPhoto).map(r => r.id).join(',')
  useEffect(() => {
    if (viewingAs || !withPhoto) return undefined
    let live = true
    signAvatars(withPhoto.split(',')).then(urls => { if (live) setPhotos(urls) })
    return () => { live = false }
  }, [withPhoto, viewingAs])

  const listed = state.rows.some(r => r.me)
  return (
    <section className="acc-card acc-dir" aria-labelledby="acc-dir-h" aria-busy={state.status === 'loading' || undefined}>
      <div className="acc-titles">
        <h2 className="acc-h2" id="acc-dir-h">{COPY.directory}</h2>
        <span className="acc-sub">{COPY.directoryLine(productName)}</span>
      </div>
      {state.status === 'error' && (
        <div className="acc-dir-failed">
          <p className="acc-msg" role="alert">{COPY.directoryFailed}</p>
          <button type="button" className="acc-btn-line acc-btn--small" onClick={load}>{COPY.tryAgain}</button>
        </div>
      )}
      {state.status === 'ready' && state.rows.length === 0 && <p className="acc-text">{COPY.directoryEmpty(productName)}</p>}
      {state.status === 'ready' && state.rows.length > 0 && !listed && (
        <p className="acc-dir-nudge">{COPY.notListed} <Link to="/account#profile">{COPY.openAccount}</Link></p>
      )}
      {state.rows.length > 0 && (
        <ul className="acc-dir-list">
          {state.rows.map(r => (
            <li key={r.id} className="acc-person">
              <span className="acc-avatar" aria-hidden="true">
                {photos[r.id] ? <img src={photos[r.id]} alt="" onError={() => setPhotos(p => ({ ...p, [r.id]: null }))} /> : r.initials}
              </span>
              <span className="acc-person-text">
                <span className="acc-person-name">{r.name}{r.me && <span className="acc-you">{COPY.you}</span>}</span>
                {r.group && <span className="acc-person-group">{r.group}</span>}
                {r.location && <span className="acc-person-loc">{r.location}</span>}
                {r.about && <span className="acc-person-about">{r.about}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
